import { defineComponent as _defineComponent } from 'vue'
import {reactive, onMounted} from 'vue';
import loginApi from '@/api/login';
import {ElMessage} from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  __name: 'database',
  emits: ['update'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

// do not use same name with ref
const form = reactive({
	ip: '127.0.0.1',
	database: 'smanga',
	port: '3306',
	userName: 'smanga',
	passWord: 'smanga',
});

onMounted(async () => {
	const res = await loginApi.database_get();

	if (res.code === 0) {
		Object.assign(form, res);
	}

	await check();
});

async function check() {
	if (!form_check()) return false;
	const res = await loginApi.database_check(form);
	emit('update', res.code === 0);
}

function form_check() {
	if (!form.ip) {
		ElMessage.warning('请填写ip地址');
		return false;
	}
	if (!form.userName) {
		ElMessage.warning('请填写用户名');
		return false;
	}
	if (!form.passWord) {
		ElMessage.warning('请填写密码');
		return false;
	}
	if (!form.port) {
		ElMessage.warning('请填端口');
		return false;
	}

	return true;
}

async function setting() {
	if (!form_check()) return false;
	const res = await loginApi.database_set(form);
	emit('update', res.code === 0);
}

const __returned__ = { emit, form, check, form_check, setting }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})